// extracted by mini-css-extract-plugin
export default {"label":"lastest-bet_label__YmTT1","panel":"lastest-bet_panel__wg9qq","tabs":"lastest-bet_tabs__Ihw+h","tab":"lastest-bet_tab__m5vlh","active":"lastest-bet_active__FcBlX"};